// @flow
import { useEffect, useState } from 'react';
/*::
  type Debounced = [
    string,
    (debouncedValue: string) => void,
  ]
*/

/**
 * Adds debouncing to a value and changeHandler
 */

export var useDebounce = function useDebounce(value
/*: string */
, onChange
/*: (value: string) => void */
, debounceTimeout
/*: number */
)
/*: Debounced */
{
  if (debounceTimeout === void 0) {
    debounceTimeout = 300;
  }

  var _useState = useState(value),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  var _useState2 = useState(false),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  useEffect(function () {
    var handler;

    if (mounted) {
      handler = setTimeout(function () {
        onChange(debouncedValue);
      }, debounceTimeout);
    }

    setMounted(true);
    return function () {
      return clearTimeout(handler);
    };
  }, [debouncedValue, debounceTimeout]);
  useEffect(function () {
    setDebouncedValue(value);
  }, [value]);
  return [debouncedValue, setDebouncedValue];
};